import Dashboard from "./pages/dashboard";
import InterviewAdvanceSearchPage from "./pages/Interview/AdvanceSearch/InterviewAdvanceSearchPage";
import InterviewAdvanceSearchPageTest from "./pages/Interview/AdvanceSearchTest/InterviewAdvanceSearchPageTest";
import NewInterview from "./pages/Interview/NewInterview";
import InterviewSettings from "./pages/InterviewSettings/InterviewSettings";
import PrecandidateIndex from "./pages/precandidate";
import ReportPage from "./pages/Reports/ReportPage";
import UsersPage from "./pages/users";
import ViewInterview from "./pages/Interview/ViewInterview/ViewInterview";
import InterviewDetails from "./pages/Interview/ReApplications/interviewDetails";
import InterviewRequestPage from "./pages/Interview/ReApplications/ReApplicationsPage";
import HiredCandidatesPage from "./pages/HiredCandidates/HiredCandidatesPage";
import PreProposalsPage from "./pages/Proposals/PreProposalsList";
import ProjectEstimationPage from "./pages/Proposals/ProjectEstimationPage";
import HelpPage from "./pages/HelpPage";
import EditRolePermission from "./pages/PermissionsSettings/EditRolePermission";
import PermissionPage from "./pages/PermissionsSettings/PermissionsPage";
import EditUserPermissions from "./pages/PermissionsSettings/EditUserPermissions";
import InterviewDocPage from "./pages/Interview/List/ListToViewDoc/InterviewDocPage";
import FileContentSearchPage from "./pages/Files/FileContentSearchPage";

import MasssImportPage from "./pages/precandidate/Import/MassImportPage";
import InterviewPage from "./pages/Interview/List/InterViewPage";
import { ReportGlobalPage } from "./pages/Reports/ReportGlobalPage";
import RequestToForget from "./pages/management/RequestToForget";
import DOCOnlineEdit from "./pages/Interview/EditDocOnline/DOCOnlineEdit";
import CandidatePage from "./pages/Global/Candidate/CandidatesPage";
import InterviewDetailsPage from "./pages/Global/Interviews/InterviewDetailsPage";
import PrecandidateDetailsPage from "./pages/Global/Precandidates/PrecandidateDetailsPage";
import DocOnlineList from "./pages/Interview/EditDocOnline/List/DocOnlineList";
import IntelligentSearchPage from "./pages/SemanticSearch/SemanticSearchPage";
export const routes = [
  { path: "/", handler: Dashboard, permissions: [], exact: true },
  { path: "/dashboard", handler: Dashboard, permissions: [] },
  {
    path: "/reports",
    handler: ReportPage,
    permissions: ["Reports_View"],
    exact: true
  },
  {
    path: "/reports/global",
    handler: ReportGlobalPage,
    permissions: ["Reports_View_All"]
  },

  {
    path: "/precandidate/create/",
    handler: PrecandidateIndex,
    permissions: ["Create_Edit_PreCand"]
  },
  {
    path: "/precandidate/import",
    handler: MasssImportPage,
    permissions: ["Import_PreCand"]
  },
  {
    path: "/precandidate/:id",
    handler: PrecandidateIndex,
    permissions: ["List_View_PreCand"]
  },
  {
    path: "/precandidate",
    handler: PrecandidateIndex,
    permissions: ["List_View_PreCand"]
  },

  {
    path: "/users/",
    handler: UsersPage,
    permissions: ["User_Management_List"]
  },

  {
    path: "/InterviewSettings/",
    handler: InterviewSettings,
    permissions: ["InterviewSettings_List_Quiz"]
  },
  {
    path: "/interview/advanceSearch",
    handler: InterviewAdvanceSearchPageTest,
    permissions: ["Use_Advanced_Search"]
  },
  {
    path: "/interview/advanceSearchOld",
    handler: InterviewAdvanceSearchPage,
    permissions: ["Use_Advanced_Search"]
  },
  {
    path: "/interview/createoredit/:id/",
    handler: NewInterview,
    permissions: ["Create_Edit_Interview"]
  },
  {
    path: "/interview/createOrEdit/",
    handler: NewInterview,
    permissions: ["Create_Edit_Interview"]
  },
  {
    path: "/interview/view/:id/",
    handler: ViewInterview,
    permissions: ["List_View_Interview"]
  },
  {
    path: "/interview/view*",
    handler: ViewInterview,
    permissions: ["List_View_Interview"]
  },
  {
    path: "/interview/10/1*",
    handler: InterviewPage,
    permissions: ["List_View_Interview"]
  },
  {
    path: "/interview/reapplications/:id/:interviewRequestId",
    handler: InterviewDetails,
    permissions: ["List_View_Interview"]
  },
  {
    path: "/interview/reapplications",
    handler: InterviewRequestPage,
    permissions: ["List_View_Reapplications"]
  },
  {
    path: "/interview",
    handler: InterviewPage,
    permissions: ["List_View_Interview"]
  },
  {
    path: "/hiredCandidates",
    handler: HiredCandidatesPage,
    permissions: ["Hired_Candidates_List_Change"]
  },
  {
    path: "/hiredCandidates/10/1/*",
    handler: HiredCandidatesPage,
    permissions: ["Hired_Candidates_List_Change"]
  },
  {
    path: "/preproposals/",
    handler: PreProposalsPage,
    permissions: ["List_View_PreProposal"]
  },
  {
    path: "/proposals/projectEstimation/:interviewId",
    handler: ProjectEstimationPage,
    permissions: ["Use_Project_Simulation"]
  },
  {
    path: "/proposals/projectEstimation",
    handler: ProjectEstimationPage,
    permissions: ["Use_Project_Simulation"]
  },
  {
    path: "/help/",
    handler: HelpPage,
    permissions: []
  },
  {
    path: "/permissions/editrole/:roleId",
    handler: EditRolePermission,
    permissions: ["Permissions_CRUD"]
  },
  {
    path: "/permissions/Edit/:userId",
    handler: EditUserPermissions,
    permissions: ["Permissions_CRUD"]
  },
  {
    path: "/permissions/",
    handler: PermissionPage,
    permissions: ["Permissions_CRUD"]
  },
  {
    path: "/InterviewDocPage",
    handler: InterviewDocPage,
    permissions: ["View_DocOnline_List"]
  },
  {
    path: "/FileContentSearch",
    handler: FileContentSearchPage,
    permissions: ["Use_File_Search"]
  },
  {
    path: "/intelligent-search",
    handler: IntelligentSearchPage,
    permissions: [] // public route, no special permissions required
  },
  {
    path: "/interviews/docslist",
    handler: DocOnlineList,
    permissions: []
  },

  {
    path: "/management/forgetcandidate",
    handler: RequestToForget,
    permissions: ["Forget_Candidate_by_Email"]
  },

  {
    path: "/interviews/DOCEdit/:interviewId/:docOnlineLanguageId",
    handler: DOCOnlineEdit,
    permissions: []
  },

  {
    path: "/interviews/DOCEdit/:id",
    handler: DOCOnlineEdit,
    permissions: []
  },

  {
    path: "/global/candidates/:searchTerm",
    handler: CandidatePage,
    permissions: ["International_Mobility"]
  },
  {
    path: "/global/candidates",
    handler: CandidatePage,
    permissions: ["International_Mobility"]
  },
  {
    path: "/global/interview/:id/:searchTerm",
    handler: InterviewDetailsPage,
    permissions: ["International_Mobility"]
  },
  {
    path: "/global/screencall/:id/:searchTerm",
    handler: InterviewDetailsPage,
    permissions: ["International_Mobility"]
  },
  {
    path: "/global/precandidate/:id/:searchTerm",
    handler: PrecandidateDetailsPage,
    permissions: ["International_Mobility"]
  }
];
